import { competitionService } from './competition';

function leaderboard(scores, field) {
  const totals = {};
  scores.filter(s => s[field]).forEach(s => {
    const entry = totals[s[field]] || (totals[s[field]] = { [field]: s[field], totalPoints: 0, activities: [] });
    entry.totalPoints += s.points;
    entry.activities.push({ activityId: s.activityId, points: s.points, placement: s.placement });
  });
  return Object.values(totals).sort((a, b) => b.totalPoints - a.totalPoints);
}
let activeEventId;
export const scoringService = {
  register(masterEventId) { activeEventId = masterEventId; },
  getForMasterEvent(masterEventId) { return competitionService.peek(masterEventId).scores; },
  getForActivity(activityId) { return competitionService.peek(activeEventId).scores.filter(s => s.activityId === activityId); },
  async setScores(masterEventId, activityId, rankings) {
    await competitionService.command(masterEventId, activityId, 'setScores', { rankings });
  },
  getLeaderboard(masterEventId) { return leaderboard(this.getForMasterEvent(masterEventId), 'userId'); },
  getTeamLeaderboard(masterEventId) { return leaderboard(this.getForMasterEvent(masterEventId), 'teamId'); },
  async clearForActivity(activityId) {
    await competitionService.command(activeEventId, activityId, 'clearScores');
  },
};
